/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-unknown-property */

import React, { SetStateAction } from 'react';
import html2canvas from 'html2canvas';
import './CustomMapControl.css';
import { IconWithTooltip } from '../../globalUtils/globalIcons';
import { toast } from 'react-toastify';
interface ICustomMapControlProps {
    mapCenter: { [key: string]: number };
    setMapCenter: React.Dispatch<SetStateAction<{ [key: string]: number }>>;
    mapZoom: number;
    setMapZoom: React.Dispatch<SetStateAction<number>>;
    alertCount: number;
    enableUserInteraction: boolean;
    setEnableUserInteraction: React.Dispatch<SetStateAction<boolean>>;
    handleAlarmButtonClicked: () => void;
}



const CustomMapControl: React.FC<ICustomMapControlProps> = (props) => {
    const { mapCenter, setMapCenter, mapZoom, setMapZoom, alertCount, enableUserInteraction, setEnableUserInteraction, handleAlarmButtonClicked } = props;


    const handleZoomIn = () => {
        setMapZoom(prev => prev + 1);
    }

    const handleZoomOut = () => {
        if (mapZoom == 0) return;
        setMapZoom(prev => prev - 1);
    }

    const handleResetMap = () => {
        setMapCenter({ lat: 20.5, lng: 78.9 });
        setMapZoom(5);
    }

    const captureMapScreen = async (divClass: string = 'noc-dashboard-live-topology-map-container'): Promise<void> => {
        /*
            Converts the html of Google map to canvas to generate snapshot of map

            Args:
                divClass: Class of the div we want to capture (default value points to map container)
        */

        const element: HTMLElement = document.getElementsByClassName(divClass)?.[0] as HTMLElement

        if (!element) {
            return;
        }
        const capturingToastId = toast.info('Capturing the map…');
        try{
        const canvas = await html2canvas(element, {
            useCORS: true, // important for map tiles
            allowTaint: true,
            logging: false,
        })
        const snapShotUrl = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = snapShotUrl;
        link.download = 'Live charger topology map.png';
        link.click();
        toast.dismiss(capturingToastId);
        toast.success('Map Captured succesfully');}
        catch(error){
            toast.dismiss(capturingToastId);
            toast.error('Failed to capture the map');
        }

    }

    return (
        <div className='noc-dashboard-map-controls-wrap'>
            <div className='noc-dashboard-map-controls-alert-icon'>
                <img src='/images/AlarmBell.png' alt='' width={'50px'} height={'50px'} onClick={handleAlarmButtonClicked} />
               <div className='noc-dashboard-map-controls-alert-count'>{alertCount > 99 ? '99+' : alertCount}</div>
            </div>
            <div className='noc-dashboard-map-navigation-controls'>
                <div
                    className='noc-dashboard-map-controls-capture-map-icon-container'
                    onClick={() => captureMapScreen('noc-dashboard-body-map-container')}
                >
                    <IconWithTooltip iconClassName='noc-dashboard-map-controls-capture-map-icon'
                        toolTipText='Capture Map' containerClassName={'noc-dashboard-map-controls-icon'} />
                </div>

                {/* <div
                    className='noc-dashboard-map-controls-user-interaction-icon'
                    onClick={() => setEnableUserInteraction(prev => !prev)}
                >
                    {
                        enableUserInteraction ?
                            <IconWithTooltip iconClassName='noc-dashboard-map-controls-disable-user-interaction-icon'
                                toolTipText='Disable User Interaction'
                                containerClassName={'noc-dashboard-map-controls-icon'} />
                            :
                            <IconWithTooltip iconClassName='noc-dashboard-map-controls-enable-user-interaction-icon'
                                toolTipText='Enable User Interaction'
                                containerClassName={'noc-dashboard-map-controls-icon'}
                            />
                    }
                </div> */}

                <div
                    className='noc-dashboard-map-control-reset-map'
                    onClick={handleResetMap}
                >
                    <IconWithTooltip iconClassName='noc-dashboard-map-control-reset-map-icon'
                        toolTipText='Fit to View'
                        containerClassName={'noc-dashboard-map-controls-icon'}
                    />
                </div>
                <div
                    className='noc-dashboard-map-control-zoom-in'
                    onClick={handleZoomIn}
                >
                    <IconWithTooltip iconClassName='noc-dashboard-map-control-zoom-in-icon'
                        toolTipText='Zoom In'
                        containerClassName={'noc-dashboard-map-controls-icon'}
                    />
                </div>
                <div
                    className='noc-dashboard-map-control-zoom-out'
                    onClick={handleZoomOut}
                >
                    <IconWithTooltip iconClassName='noc-dashboard-map-control-zoom-out-icon'
                        toolTipText='Zoom Out'
                        containerClassName={'noc-dashboard-map-controls-icon'}
                    />
                </div>

            </div>
         </div>
    )
}



export default CustomMapControl;